import { service } from '@maia/claim';
import { useMutation } from '@tanstack/react-query';
import { ICreateClaimEntity } from '@maia/shared';

type UseCreateClaimParams = Parameters<typeof service.createClaim>[1];

export function useCreateClaim(
  customerGuid: string,
  onSuccess?: (data: ICreateClaimEntity) => void,
  onError?: () => void,
) {
  return useMutation({
    mutationFn: (args: UseCreateClaimParams) =>
      service.createClaim(customerGuid, args),
    onSuccess,
    onError,
  });
}
